import { createAuthStore, createThemeStore } from "@pack-it-up/viewmodel";
import type { AllRepositories } from "@pack-it-up/core";
import type { SecureStorage } from "@pack-it-up/viewmodel";

// The session-independent stores, created once at startup from composed deps. Session-
// scoped stores (home/friends/managed, keyed to the signed-in userId) are added by the
// later T15 slices inside the signed-in subtree. `ReturnType` avoids importing zustand
// directly (the store library is confined to viewmodel/bindings, Doc 01 §5).
export interface RootStores {
  auth: ReturnType<typeof createAuthStore>;
  theme: ReturnType<typeof createThemeStore>;
}

export interface RootStoreDeps {
  repos: AllRepositories;
  storage: SecureStorage;
}

export const createRootStores = ({ repos, storage }: RootStoreDeps): RootStores => ({
  auth: createAuthStore({ auth: repos.auth, profiles: repos.profiles }),
  theme: createThemeStore({ storage }),
});
